import { gql } from "@apollo/client";

const GENERATE_SHOWING_TIME_AGENT_CONFIGURATION_URL = gql`
  query generateShowingTimeAgentConfigurationUrl {
    generate_showing_time_agent_configuration_url {
      url
    }
  }
`;

export default GENERATE_SHOWING_TIME_AGENT_CONFIGURATION_URL;
